import { css } from 'styled-components'

export const COLOR = {
  RED: 'red',
  BLUE: 'blue',
  GREY: 'grey'
}

const COLORS = {
  [COLOR.BLUE]: {
    normal: '#03B0F6',
    hover: '#42C0F3',
    active: '#0384B8'
  },
  [COLOR.RED]: {
    normal: '#FF0000',
    hover: '#FF4646',
    active: '#E10303'
  },
  [COLOR.GREY]: {
    normal: '#939393',
    hover: '#939393',
    active: '#939393'
  }
}

export default {
  color: (props, color = 'blue') => css`
    color: ${COLORS[color].normal};

    &:hover {
      color: ${COLORS[color].hover};
    }

    &:active {
      color: ${COLORS[color].active};
    }
  `
}
